import React, { Component, Fragment } from 'react'
//css
import '../css/inicio.css';
import '../css/terminos-condiciones.css';
//componentes
import Nav from '../components/nav/Nav';
import Footer from '../components/footer/Footer';

class TerminosCondiciones extends Component {
    render() {
        return (
            <Fragment>
                <Nav />
                <div className="contenedorTitulo">
                    <p className="titulo">Términos y condiciones</p>
                </div>
                <div className="d-md-flex flex-md-equal w-100 my-md-3 pl-md-3">
                    <p>
                        
                    </p>
                </div>
                <Footer />
            </Fragment>
        )
    }
}

export default TerminosCondiciones;